import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { MessageTemplateActions } from "../../../../../../../types/MessageTemplateEnums";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const SMSLateStatusCellContent: React.FC<SMSLateStatusCellContent.Props> = ({
	item,
	language,
	type,
}) => {
	const { t } = useTranslation();

	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const _type =
			(
				{
					[MessageTemplateActions.LATE]: ColumnId.SMSLateStatus,
					[MessageTemplateActions.WILL_BE_TIME]:
						ColumnId.SMSWillBeAtStatus,
					[MessageTemplateActions.CAR_NOT_FOUND]:
						ColumnId.SMSCarNotFoundStatus,
					[MessageTemplateActions.OUTPUT_PASSENGERS]:
						ColumnId.SMSAwaitingPassengersStatus,
					[MessageTemplateActions.WITH_PASSENGERS]:
						ColumnId.SMSWithPassengersStatus,
					[MessageTemplateActions.ORDER_SUCCESSFULLY_COMPLETED]:
						ColumnId.SMSOrderCompletedStatus,
					[MessageTemplateActions.DRIVER_SWITCHED]:
						ColumnId.SMSExecutorSwitchedStatus,
				} as const
			)[type] ?? null;

		const preparedCell = item?.cellsForTable?.[_type];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item.smsMessages, type, t);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.cellsForTableSettings?.lang,
		item.smsMessages,
		language,
		t,
		type,
	]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace SMSLateStatusCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
		type: MessageTemplateActions;
	}
}

export default SMSLateStatusCellContent;
